import types from './types';
import { getErrorMessage } from '../../utils';
import { t } from 'i18next';

export default ({ type, request, data }) => {
  switch (type) {
    case types.SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_SUCCESS:
      if (!data.openConfirmationModal) {
        return {
          title: t('message.title.success.save.inventory'),
          type: 'success'
        };
      } else return false;
    case types.SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_FAILURE:
      return {
        title: t('message.title.error.save.inventory'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.DELETE_INVENTORY_SUCCESS:
      return {
        title: t('message.title.success.delete.inventory'),
        type: 'success'
      };
    case types.DELETE_INVENTORY_FAILURE:
      return {
        title: t('message.title.error.delete.inventory'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.GET_INVENTORY_FAILURE:
    case types.GET_DELETED_INVENTORY_FAILURE:
      return {
        title: t('message.title.error.get.inventory'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.GET_INVENTORY_INITIAL_DATA_FAILURE:
      return {
        title: t('message.title.error.get.inventory.initial.data'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.MARK_AS_CHECKED_FAILURE:
      return {
        title: t('message.title.error.mark.inventory.checked'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.MARK_AS_CHECKED_SUCCESS:
      if (data.warningCount > 0) {
        return {
          title: t('message.title.warn.mark.inventory.checked', { warningCount: data.warningCount }),
          type: 'warning'
        };
      }
      else {
        return {
          title: t('message.title.success.mark.inventory.checked'),
          type: 'success'
        };
      }
    case types.CREATE_INVENTORIES_QR_STICKERS_PDF_FAILURE:
      return {
        title: t('message.title.error.get.inventory.chemical.product.labels'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };

    default:
      return false;
  }
};
